module.exports = _.isDate;